import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const TemplateEmailModule = lazy(loadModule);

export default TemplateEmailModule;
